import React from "react";

const DomainToLive = (props) => {
  const { toggleModel, isModalOpen, item, message } = props;

  let subdomain = "";
  if (item !== undefined && item.domain_name !== undefined) {
    let subdomainList = item.domain_name.split(".");

    if (subdomainList.length > 2) {
      for (var i = 0; i < subdomainList.length - 2; i++) {
        if (subdomain !== "") {
          subdomain = subdomain + ".";
        }
        subdomain = subdomain + subdomainList[i];
      }
    }
  }

  return (
    <>
      <div className={isModalOpen ? "quick_sidebar_open" : ""}>
        <div className=" quick-sidebar p-0">
          <a
            href="#"
            onClick={toggleModel}
            className="close-quick-sidebar"
            style={{ top: 0, right: "10px", zIndex: 1 }}
          >
            <i className="fas fa-times fa-lg" />
          </a>
          <div className="view">
            <div className="table_Box dataTables_wrapper">
              <div className="modal-header">
                <h4 className="mb-0"> Domain to Live </h4>
              </div>
              <div className="table_Body">
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <label className="w-100 text-truncate">
                          {" "}
                          Check Domain is Live{" "}
                        </label>

                        {message.succMessage !== undefined &&
                          message.succMessage !== "" ? (
                          <>
                            <span className="text-success">
                              <i className="fas fa-check-circle mr-2"></i>
                              {message.succMessage}
                            </span>
                          </>
                        ) : (
                          ""
                        )}
                        {message.failMessage !== undefined &&
                          message.failMessage !== "" ? (
                          <>
                            <span className="text-danger">
                              <i className="fas fa-check-circle mr-2"></i>
                              {message.failMessage}
                            </span>
                          </>
                        ) : (
                          ""
                        )}
                        <div className="input-group">
                          <input
                            placeholder={item.domain_name}
                            className="form-control"
                            maxLength={255}
                            decimal={0}
                            disabled
                          />
                          <div className="input-group-append ">
                            <a
                              className="btn btn-success d-flex align-items-center"
                              onClick={() => props.checkLive(item.domain_name)}
                            >
                              CheckLive
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <h5>If your domain is not live , please follow the below </h5>
                  <h6> Adding A record to your DNS </h6>
                  <ul className="text-black-50">
                    <li>
                      {" "}
                      name :{" "}
                      <span className="text-bold text-info">
                        {subdomain !== "" ? subdomain : "@"}
                      </span>{" "}
                    </li>
                    <li>
                      {" "}
                      Content :{" "}
                      <span className="text-bold text-info">14.96.14.254</span>
                    </li>
                    <li>
                      {" "}
                      Type : <span className="text-bold text-info">
                        {" "}
                        A
                      </span>{" "}
                    </li>
                    <li>
                      {" "}
                      Login to the domain provider's account (For example,
                      GoDaddy, namecheap, among others) where your domain's name
                      server is pointed.{" "}
                    </li>
                    <li>
                      {" "}
                      Access your domain and navigate to it's DNS page (DNS
                      Manager or DNS Control Panel or Advanced DNS editor).{" "}
                    </li>
                    <li> Create A DNS Record as mentioned above.</li>
                    <li>
                      {" "}
                      Once Saved the A record in domain provider's account,
                      Comeback here and Click below the CheckLive button to
                      confirm the Domain Verification{" "}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {(isModalOpen)?<div className="quick-sidebar-overlay"></div>:""}
    </>
  );
};
export default DomainToLive;
